import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { createRentalTypes, rentalCostPreviewT } from "dora-contracts";

const { postRentalT, updateRentalT, rentalT, rentalsT } = createRentalTypes({
  decimal: t.string,
});

export type PostRental = t.TypeOf<typeof postRentalT>;
export type Rental = t.TypeOf<typeof rentalT>;
// Body of PUT /api/rentals/:id: the same header fields as POST plus one entry
// per existing equipment line (quantity is not editable, only the rate).
export type UpdateRental = t.TypeOf<typeof updateRentalT>;
export type RentalCostPreview = t.TypeOf<typeof rentalCostPreviewT>;
export const decodeRentals = decode(rentalsT);
export const decodeRental = decode(rentalT);
export const decodeRentalCost = decode(rentalCostPreviewT);
